module.exports = __webpack_public_path__ + "media/images/flags/32/Sierra-Leone-7797620c5f8b3845a73dfba7359fd634.png";